<div *ngIf="(overlayStatus$ | async) as overlayStatus"
    class="order-delivery-view order-delivery-view--force-min-width-override" (click)="checkIfClickedOnBackdrop($event)"
    [class.order-delivery-view--backdrop]="overlayStatus !== OverlayStatusEnum.Idle">
    <div [class.pointer-events-none]="overlayStatus !== OverlayStatusEnum.Idle" class="main-filters">
        <div class="main-filters__column-1">
            <select (change)="daysModeChanged($event)">
                <option *ngFor="let dayMode of daysModeOptions" [value]="dayMode.value">{{dayMode.displayName}}</option>
            </select>
        </div>
        <div class="main-filters__column-2" *ngIf=" (this.plannerConfiguration$ | async) as config">
            <planer-range-selection (selectedDateRangeChanged)="plannerDateRangeChanged($event)"
                [selectedDateRange]="{ start: config.firstDay, end: config.lastDay}"
                [selectedDaysMode]="config.daysMode" />
        </div>
        <div class="main-filters__column-3">
            <a mat-stroked-button href="#!/app/shipmentplanning"
                *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.MODULE">
                <mat-icon>calendar_today</mat-icon>
                Planer
            </a>
        </div>
    </div>
    <div [class.pointer-events-none]="overlayStatus !== OverlayStatusEnum.Idle"
        class="order-delivery-view__secondary-filters">
        <div matTooltip="Data ostatniej aktualizacji - włącz automatyczną aktualizację"
            class="order-delivery-view__last-update-time-box  user-select-none layout-px-4 layout-py-4">
            <mat-slide-toggle class="mat-slide-toggle-system-colors" [(ngModel)]="isAutoRefreshEnabled"
                labelPosition="before">
                {{ lastUpdateDate$ | async | date :'HH:mm:ss'}}
            </mat-slide-toggle>
        </div>

        <button class="action-button--white-background" type="button"
            [disabled]="overlayStatus !== OverlayStatusEnum.Idle" mat-icon-button (click)="refreshRoutesClick()"
            matTooltip="Odśwież trasy">
            <mat-icon>sync</mat-icon>
        </button>

        <div>
            <select class="min-width-64" [formControl]="regionControl">
                <option *ngFor="let region of regions$ | async" [value]="region.Id">{{ region.Name }}</option>
            </select>
        </div>

        <div>
            <select class="min-width-64" [formControl]="departmentControl">
                <option *ngFor="let department of departments$ | async" [value]="department.Id">{{ department.Name }}
                </option>
            </select>
        </div>
        <div>
            <input type="text" [formControl]="mainSearchControl" placeholder="szukaj" />
        </div>
    </div>
    <div class="progress-bar-panel">
        <mat-progress-bar *ngIf="overlayStatus === OverlayStatusEnum.Working" mode="indeterminate"></mat-progress-bar>
    </div>


    <div [class.pointer-events-none]="overlayStatus !== OverlayStatusEnum.Idle" class="flex-grow flexContent">
        <div class="flex-grow flexContent flexColumn ">
            <div class="flex gap-2 layout-px-16">
                <div *ngFor="let day of displayedDays$ | async; let first = first; let last = last; let index = index "
                    class="displayed-days flex-grow flexContent spacebetween align-center">

                    <div>
                        <button type="button" mat-icon-button *ngIf="first" (click)="pageChanged(false)">
                            <mat-icon>arrow_back_ios_new</mat-icon>
                        </button>
                    </div>

                    <div class="flexContent flexColumn justify-center align-center">
                        <div>{{day | date: 'dd.MM.yyyy' }}</div>
                        <div class="font-weight-bolder">
                            <div
                                *ngIf="index === (this.plannerConfiguration$ | async)?.middleDayOfThePeriod; else emptyTemplate">
                                {{day | date: 'w' }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <button type="button" mat-icon-button *ngIf="last" (click)="pageChanged()">
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>

                        <div *ngIf="!last" class="displayed-days__cell-right-element">
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-grow">


                <div class="main-grid layout-px-16 gap-2 pt-2">
                    <div class="main-grid__grid-column flex-grow flexContent flexColumn gap-4"
                        *ngFor="let column of gridRowsFiltered$ | async">

                        <div *ngFor="let shipmentTask of column.shipmentTask">
                            <shipment-box [shipmentTask]="shipmentTask"
                                (markAsCompleted)="maskAsCompleted($event, true)"
                                (undoCompletion)="maskAsCompleted($event, false)"></shipment-box>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<ng-template #emptyTemplate>&nbsp;</ng-template>